import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=97311eec&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=97311eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97311eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97311eec')) {
      api.createRecord('97311eec', component.options)
    } else {
      api.reload('97311eec', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=97311eec&scoped=true&", function () {
      api.rerender('97311eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PSsnpjNJuLRb/JS/comp/DateRangeExt.vue"
export default component.exports